// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class LibraryCardReadingHistoryListController {
   $document: any
   $filter: any
   $log: any
   $q: any
   $scope: any
   $uibModal: any
   activationStatusIsEditable: any
   alerts: any
   allSelected: any
   apiService: any
   docs: any
   emptyListMessage: any
   error: any
   i18n: any
   isLoading: any
   listLoadError: any
   rawBibIds: any
   readingHistoryActivated: any
   selectedCount: any
   sierraService: any
   sortOptionSelected: any
   sortOptions: any
   success: any
   webPacOptInLink: any
   libraryCardErrorHelper: any
   constructor($scope: any, $document: any, sierraService: any, apiService: any, translationService: any, alertService: any, $q: any, $log: any, $uibModal: any, $filter: any, $rootScope: any, $authEvents: any, libraryCardErrorHelper: any) {
      this.$onInit = this.$onInit.bind(this)
      this.$onChanges = this.$onChanges.bind(this)
      this.loadReadingHistory = this.loadReadingHistory.bind(this)
      this.updateSelected = this.updateSelected.bind(this)
      this.toggle = this.toggle.bind(this)
      this.deleteEntry = this.deleteEntry.bind(this)
      this.deleteSelectedReadingHistory = this.deleteSelectedReadingHistory.bind(this)
      this.deleteAllReadingHistoryEntries = this.deleteAllReadingHistoryEntries.bind(this)
      this.deleteSomeSelectedEntries = this.deleteSomeSelectedEntries.bind(this)
      this.$scope = $scope
      this.$document = $document
      this.sierraService = sierraService
      this.apiService = apiService
      this.$q = $q
      this.$log = $log
      this.$uibModal = $uibModal
      this.$filter = $filter
      this.i18n = translationService
      this.isLoading = false
      this.docs = []
      this.rawBibIds = []
      this.selectedCount = 0
      this.allSelected = false
      this.sortOptions = [ 
         { sortBy: 'checkoutDate', translation: translationService.translations.CHECK_OUT_DATE, dateOrCode: true },
         { sortBy: 'author', translation: translationService.translations.AUTHOR, dateOrCode: false },
         { sortBy: 'title', translation: translationService.translations.TITLE, dateOrCode: true }
      ]
      this.sortOptionSelected = { sortBy: '', translation: '', dateOrCode: false }
      this.alerts = alertService
      this.readingHistoryActivated
      this.emptyListMessage = this.i18n.translations.READING_HISTORY_INACTIVE
      this.activationStatusIsEditable = true
      this.webPacOptInLink = this.sierraService.getWebPacReadingHistoryOptInLink()
      this.libraryCardErrorHelper = libraryCardErrorHelper

      $rootScope.$on($authEvents.LOGOUTSUCCESS, () => this.docs = [])
   }

   $onInit() {
      this.loadReadingHistoryWhenReady()      
   }

   $onChanges(changesObj: any) {
      if (changesObj.reloadTrigger.currentValue) {
         return this.loadReadingHistoryWhenReady()
      }
   }

   loadReadingHistoryWhenReady(){
      this.isLoading = true
      return this.sierraService.patronInfoLoadedPromise.promise
         .then(() => this.loadReadingHistory())
         .catch((err: any) => this.handleError(err))
   }

   loadReadingHistory(prevActionSuccessMessage = "", prevActionErrorMessage = "") {
      this.readingHistoryActivated = false
      this.listLoadError = false
      const getId = this.sierraService.getIdFromUrlString
      this.isLoading = true
      return this.sierraService
         .getReadingHistoryIfActivatedOrInferrable()
         .then((resp: any) => {
            if (resp.data.readingHistoryActivation !== false) {
               this.readingHistoryActivated = true
               this.activationStatusIsEditable = this.sierraService.activationStatusIsEditable
               this.rawBibIds = _.map(resp.data.entries, (ent: any) => ({
                  bibId: getId(ent.bib ? ent.bib : ent.item),
                  checkoutId: ent.id,
                  outDate: ent.outDate
               }))

               const apiQuery = this.sierraService.createApiQuery(this.rawBibIds)

               if (apiQuery) {
                  return this.apiService.get('search', apiQuery, {avoidUpdateFire: true})
               }
            }
         }).then((resp: any) => {
            if (resp && resp.data) {
               this.docs = _.map(this.rawBibIds, (sierraReadingHistoryDoc: any) => {
                  let doc = this.sierraService.findDocIfExists(resp.data.documents, sierraReadingHistoryDoc.bibId)
                  if (!doc) {
                     doc = this.sierraService.createDummyDoc(this.i18n.translations.NO_RESOURCE_FOUND)
                  }

                  const checkoutId = getId(sierraReadingHistoryDoc.checkoutId)
                  const {
                     bibId
                  } = sierraReadingHistoryDoc
                  const checkoutDate = sierraReadingHistoryDoc.outDate
                  const author = doc.authors?.length ? doc.authors[0].fullname : undefined
                  const {
                     title
                  } = doc

                  return { doc, checkoutId, bibId, checkoutDate, author, title }
               })
               return this.sortList()
            } else {
               return this.docs = []
            }
         }) // no response
         .then(() => {
            if ((this.docs.length === 0) && this.readingHistoryActivated) {
               this.emptyListMessage = this.i18n.translations.READING_HISTORY_EMPTY
            }
            if (prevActionSuccessMessage) {
               this.success = prevActionSuccessMessage
               this.alerts.pulseAlert('libraryCardSuccess', this.success, 5000)
            }
            if (prevActionErrorMessage) {
               this.error = prevActionErrorMessage
               this.alerts.pulseAlert('libraryCardError', this.error, 10000)
            }

            this.isLoading = false
            return this.updateSelected()
         }).catch((err: any) => {
            return this.handleError(err)
         })
   }

   handleError(err: any) {
      this.$log.error(err)
      this.isLoading = false
      this.listLoadError = true
      const errorMessage = this.libraryCardErrorHelper.getLibraryCardErrorMessage(err, this.sierraService, this.i18n)
      this.error = this.i18n.translate(this.i18n.translations.READING_HISTORY_ERROR, {error: errorMessage})
      return this.alerts.setAlert('libraryCardListLoadError', this.error)
   }

   sortList(sortOption = this.sortOptions[0]) {
      this.sortOptionSelected = sortOption
      return this.docs = sortOption.dateOrCode ? this.$filter('orderBy')(this.docs, sortOption.sortBy) : this.$filter('localeSort')(this.docs, sortOption.sortBy)
   }

   getSortByOption() {
      return this.sortOptionSelected.translation
   }

   updateSelected() {
      this.selectedCount = _.filter(this.docs, (doc: any) => doc.selected).length
      return this.allSelected = this.selectedCount === this.docs.length
   }

   toggle(doc: any) {
      _.each(this.docs, (doc: any) => { return doc.selected = this.allSelected })
      return this.updateSelected()
   }

   deleteEntry(id: any) {
      this.success = ''
      this.error = ''
      this.isLoading = true
      return this.sierraService.deleteReadingHistoryEntry(id)
         .then((data: any) => {
            this.$log.debug(' reading history entry succesfully deleted ')
            this.success = this.i18n.translations.READING_HISTORY_DELETION_SUCCESS
            this.alerts.pulseAlert('libraryCardSuccess', this.success, 5000)
            return this.loadReadingHistory()
         }).catch((err: any) => {
            this.$log.error('error deleting reading history entry ', err)
            this.isLoading = false
            window.scrollTo(0,0)
            this.error = this.i18n.translations.READING_HISTORY_DELETION_ERROR
            return this.alerts.pulseAlert('libraryCardError', this.error, 10000)
         })
   }

   deleteSelectedReadingHistory() {
      const selectedDocs = _.filter(this.docs, (doc: any) => doc.selected)
      if (selectedDocs.length === this.docs.length) {
         return this.deleteAllReadingHistoryEntries()
      } else {
         return this.deleteSomeSelectedEntries()
      }
   }

   deleteAllReadingHistoryEntries() {
      this.success = ''
      this.error = ''
      this.isLoading = true
      return this.sierraService.deleteAllReadingHistoryEntries()
         .then((data: any) => this.loadReadingHistory(this.i18n.translations.READING_HISTORY_DELETION_SUCCESS))
         .catch((err: any) => {
            this.$log.error('error deleting all reading history ', err)
            this.isLoading = false
            window.scrollTo(0,0)
            this.error = this.i18n.translations.READING_HISTORY_DELETION_ERROR_ALL
            return this.alerts.pulseAlert('libraryCardError', this.error, 10000)
         })
   }

   deleteSomeSelectedEntries() {
      this.success = ''
      this.error = ''
      this.isLoading = true
      const selectedDocs = _.filter(this.docs, (doc: any) => doc.selected)
      const deletePromises = _.map(selectedDocs, (doc: any) => {
         return this.sierraService.createAlwaysSuccessPromise(this.sierraService.deleteReadingHistoryEntry(doc.checkoutId), doc.checkoutId)
      })

      const handleResults = (results: any) => { 
         this.isLoading = false
         const successDocs: any = []
         const failedDocsWithError = []
         _.map(results, (result: any) => { 
            if (result.status === 'success') {
               return successDocs.push(result.checkoutId)
            } else {
               return failedDocsWithError.push({checkoutId: result.checkoutId, error: result.original})
            }
         })
      
         if (successDocs.length === selectedDocs.length) { // All success, reload history with success message
            return this.loadReadingHistory(this.i18n.translations.READING_HISTORY_DELETION_SUCCESS_ALL)
         } else if (failedDocsWithError.length && !successDocs.length) { // All failure, show failure message without reloading history
            this.error = this.i18n.translate(this.i18n.translations.READING_HISTORY_DELETION_SOME_ERROR, {number: failedDocsWithError.length})
            return this.alerts.pulseAlert('libraryCardError', this.error, 10000)
         } else if (!failedDocsWithError.length && successDocs.Length) { // Some Success and some failure, reload checkouts with failure message
            return this.loadReadingHistory('', this.i18n.translate(this.i18n.translations.CHECKED_OUT_RENEWAL_SOME_ERROR, {number: failedDocsWithError.length}))
         }
      }

      return this.$q
         .all(deletePromises) 
         .then(handleResults) 
         .catch((errors: any) => {
            this.error = this.i18n.translations.READING_HISTORY_DELETION_ERROR
            return this.alerts.pulseAlert('libraryCardError', this.error, 10000)
         })
   }

   deleteHistoryAndOptOutIfUserConfirms() {
      const dialogInstance = this.$uibModal.open({
         templateUrl: '/assets/libraryCard/confirmActionDialog.html',
         controller: 'libraryCardConfirmActionDialogController',
         controllerAs: 'vm',
         backdrop: false,
         keyboard: true,
         size: 'sm',
         openedClass: 'confirmation-modal-open'
      })
      return dialogInstance.result
         .then(() => this.deleteHistoryAndOptOut())
         .catch(() => angular.noop) // user has clicked no and chosen not to delete
   }

   deleteHistoryAndOptOut() {
      this.isLoading = true
      return this.sierraService.deleteReadingHistoryAndOptOut()
         .then(() => { 
            return this.loadReadingHistory(this.i18n.translations.READING_HISTORY_OPT_OUT_SUCCESS)
         }).catch((err: any) => {
            this.$log.error(err)
            this.isLoading = false
            if (err?.config?.method === "DELETE") { // error occurred in deletion attempt
               this.error = this.i18n.translations.READING_HISTORY_OPT_OUT_ERROR
               return this.alerts.pulseAlert('libraryCardError', this.error, 10000)
            } else { // entries were likely deleted successfully, reload history and show error
               return this.loadReadingHistory('',this.i18n.translations.READING_HISTORY_OPT_OUT_ERROR)
            }
         })
   }

   optOut() {
      this.isLoading = true
      return this.sierraService.optOutFromReadingHistory()
         .then(() => this.loadReadingHistory())
         .catch((err: any) => {
            this.$log.error(err)
            this.isLoading = false
            this.error = this.i18n.translations.READING_HISTORY_OPT_OUT_ERROR
            return this.alerts.pulseAlert('libraryCardError', this.error, 10000)
         })
   }

   optIn() {
      this.isLoading = true
      return this.sierraService.optInToReadingHistory()
         .then(() => this.loadReadingHistory())
         .catch((err: any) => {
            this.$log.error(err)
            this.isLoading = false
            this.error = this.i18n.translations.READING_HISTORY_OPT_IN_ERROR
            return this.alerts.pulseAlert('libraryCardError', this.error, 10000)
         })
   }
}

LibraryCardReadingHistoryListController.$inject = ['$scope', '$document', 'sierraService', 'apiService', 'translationService', 'alertService', '$q', '$log', '$uibModal', '$filter', '$rootScope', '$authEvents', 'libraryCardErrorHelper']

angular.module('summonApp.controllers')
   .controller('libraryCardReadingHistoryListController', LibraryCardReadingHistoryListController)
